import React, { useState } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Card, message, Divider, Select } from "antd";
import { useSelector } from "react-redux";
import { setFormFieldValue } from "../../../../../helpers/FormHelper";
import { capitalizeFirstLetter, replaceAlbanianChars } from "../../../../../helpers/StringFormatter";
import { getErrorMessage } from "../../../../../helpers/ErrorHelper";
import ConsultHeaderCard from "../../../../../components/Common/Cards/ConsultHeaderCard";
import { EMIGRANT_RULES } from "./Rules";
import EmigrantService from "../../../../../services/Election/EmigrantService";



const Add = ({ countries, onBack, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);


    const formatRequestData = (data) => {
        const requestData = {
            country_id: setFormFieldValue(data.country),
            city: capitalizeFirstLetter(data.emigrant_city),
            city_albania: capitalizeFirstLetter(data.origin_city),
            name: capitalizeFirstLetter(data.name),
            surname: capitalizeFirstLetter(data.surname),
            phone: setFormFieldValue(data.phone),
            referues_name: capitalizeFirstLetter(data.referrer)
        }
        return requestData;
    };


    const onSave = async (e) => {
        setLoading(true);

        try {
            const data = await form.validateFields();
            const requestData = formatRequestData(data);
            const response = await EmigrantService.register(token, requestData);
            const apiResponse = response.data;
            if (apiResponse) {
                await message.success('Regjistrimi u krye me sukses!', 1);
                onSuccess();
            } else {
                await message.error("Një gabim ndodhi gjatë komunikimit me serverin!", 2);
            }
        } catch (error) {
            if (!error.values) {
                const errorMessage = getErrorMessage(error);
                await message.error(errorMessage, 2);
            }
        } finally {
            setLoading(false);
        }
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <ConsultHeaderCard
                            longTitle="Referencë e re"
                            shortTitle="Referencë e re"
                            onBack={onBack}
                        />
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card>
                            <Form
                                layout="horizontal"
                                labelCol={{ span: 6 }}
                                labelAlign="left"
                                form={form}
                            >
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider orientation="center" style={{ borderTopColor: "#a461d852" }} className="m-0">
                                            <h4 className="m-0" style={{ color: "#a461d8" }}>Të dhënat e emigrantit</h4>
                                        </Divider>
                                    </Col>
                                </Row>
                                <Row gutter={24} className="m-0 mt-5">
                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                        <Form.Item label="Shteti:" name="country" rules={EMIGRANT_RULES.country}>
                                            <Select
                                                showSearch
                                                placeholder="-Zgjidhni shtetin-"
                                                optionFilterProp="children"
                                                filterOption={(input, option) => replaceAlbanianChars(option?.children ?? '').includes(replaceAlbanianChars(input))}
                                            >
                                                {countries?.map((item) => (
                                                    <Select.Option key={item?.id} value={item?.id}>
                                                        {item?.country_name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item label="Qyteti i emigrimit:" name="emigrant_city" rules={EMIGRANT_RULES.city}>
                                            <Input type="text" placeholder="Qyteti i emigrantit..." />
                                        </Form.Item>
                                        <Form.Item label="Qyteti i origjinës:" name="origin_city" rules={EMIGRANT_RULES.city}>
                                            <Input type="text" placeholder="Qyteti i origjinës..." />
                                        </Form.Item>
                                    </Col>
                                    <Col xl={2} lg={2} md={24} sm={24} xs={24}></Col>
                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                        <Form.Item label="Emri:" name="name" rules={EMIGRANT_RULES.name}>
                                            <Input type="text" placeholder="Emri..." />
                                        </Form.Item>
                                        <Form.Item label="Mbiemri:" name="surname" rules={EMIGRANT_RULES.surname}>
                                            <Input type="text" placeholder="Mbiemri..." />
                                        </Form.Item>
                                        <Form.Item label="Telefoni:" name="phone" rules={EMIGRANT_RULES.phone}>
                                            <Input type="text" placeholder="Telefoni..." />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100 mt-0" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className="m-0 mt-1">
                                    <Col xl={13} lg={13} md={24} sm={24} xs={24}></Col>
                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                        <Form.Item label="Referuar nga:" name="referrer" rules={EMIGRANT_RULES.referrer}>
                                            <Input type="text" placeholder="Referuar nga..." />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100 mt-0" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className='mt-3'>
                                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className='text-center'>
                                        <Button
                                            type="primary"
                                            className="mr-5"
                                            style={{ width: "160px", height: '37px' }}
                                            onClick={() => onSave()}
                                            loading={loading}
                                            icon={<CheckOutlined />}
                                        >
                                            Ruaj
                                        </Button>
                                        <Button
                                            danger
                                            disabled={loading}
                                            onClick={onBack}
                                            style={{ width: "160px", height: '37px' }}
                                            icon={<CloseOutlined />}
                                        >
                                            Mbyll
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default Add;